import { bootstrapApplication } from '@/applicationHost';
import { installTranslationDomGuard } from '@/lib/translationDomGuard';

import './styles.css';

installTranslationDomGuard();

void bootstrapApplication({
  hostname: window.location.hostname,
  loadProposal: async () => {
    const { mountProposalApplication } = await import('./ProposalEntry');
    mountProposalApplication();
  },
  loadStaff: async () => {
    const { mountStaffApplication } = await import('./StaffEntry');
    mountStaffApplication();
  }
});
